var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { observer } from 'mobx-vue';
import { Component, Vue } from 'vue-property-decorator';
import ViewBacktop from './backtop.vue';
import ViewChildren from './childrenLayout.vue';
import Error from './error.vue';
import ViewProLayout from './proLayout.vue';
let default_1 = class extends Vue {
    get pageClass() {
        return lodash.join(['app-page', this.$route.name], '-');
    }
    get isNoLayout() {
        const fixNoLayout = lodash.includes([this.$Pages.Protocol_list.name], this.$route.name);
        return (fixNoLayout || lodash.eq(lodash.get(this.$route.query, 'layout'), 'no'));
    }
    get layout() {
        if (this.AppConfig.MICRO ||
            this.AppConfig.ChildrenPage ||
            this.isNoLayout) {
            return 'ViewChildren';
        }
        if (!this.AppConfig.release) {
            return 'ViewProLayout';
        }
    }
    get error() {
        return (this.AppConfig.release &&
            !this.AppConfig.ChildrenPage &&
            !lodash.includes([], this.$route.name));
    }
    mounted() { }
    updated() { }
    destroyed() { }
};
default_1 = __decorate([
    observer,
    Component({
        components: {
            ViewChildren,
            ViewProLayout,
            Error,
            ViewBacktop,
        },
    })
], default_1);
export default default_1;
